import { AnyAction } from 'redux';

import { carsActions } from '../reducer';

export const resetCarEBoxLocations = (): AnyAction => carsActions.resetEBoxLocations();
